enum PrivateEventsQueryTypesEnum {
  Managing = 'Managing',
  Participating = 'Participating',
}

export default PrivateEventsQueryTypesEnum;
